<template>
  <div>
    <div>
      <iframe
        src="https://ai.commit.kz/projects/1/chat?secret=34534217"
        width="100%"
        height="600"
        style="border: none;"
        allow="clipboard-write"
        title="AI Chat"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'CbsRagTutorial',
}
</script>

<style scoped>

</style>
